/* eslint-disable react/prop-types */
import React from "react";
import {
  TableContainer,
  TableCell,
  TableRow,
  TableHead,
  Table as MuiTable,
  Box,
  TableBody,
} from "@mui/material";
import PropTypes from "prop-types";
// import { styled } from "@mui/material/styles";
import Typography from "../../../../components/common/new/Typography/Typography";
import style from "./tableStyle";

const BLOCK = "BLOCK";
// const CHAPTER = "CHAPTER";
// const DISTRICT = "DISTRICT";
// const REGION = "REGION";
// const ZONE = "ZONE";

function Table({
  checkAllToggle,
  columns,
  rows,
  scrollable,
  columnCellStyle,
  headCellStyle,
  hasAction = false,
  searchData,
}) {
  const hierarchyValues = searchData.map((data) => data.hierarchy);
  const isBlock = hierarchyValues[0] === BLOCK;
  return (
    <TableContainer
      style={{
        ...style.container,
        ...{ overflow: scrollable ? "auto" : "hidden" },
      }}
    >
      <MuiTable aria-label="collapsible table" stickyHeader>
        <TableHead sx={{ paddingTop: "1.4rem" }}>
          <TableRow sx={{ padding: "1rem" }}>
            <TableCell
              align="left"
              colSpan={3}
              style={{
                ...style.tableHeadCell,
                ...columnCellStyle,
                paddingLeft: "0px",
                marginRight: "0px",
              }}
            />
            <TableCell
              align="left"
              // OLD: colSpan={11}
              colSpan={13}
              sx={{
                ...style.tableHeadCell,
                ...columnCellStyle,
                paddingLeft: "0px",
              }}
            >
              <Typography
                variant="small"
                weight={600}
                sx={{ color: "#000000" }}
              >
                <Box
                  sx={{
                    marginLeft: "-11px",
                    borderLeft: "1px solid rgba(94, 94, 94, 1)",
                    // borderRight: "1px solid rgba(94, 94, 94, 1)",
                  }}
                >
                  {" "}
                  MEMBERS
                </Box>
              </Typography>
            </TableCell>
            {/* {hierarchyValues[0] !== BLOCK ||
              hierarchyValues[0] === DISTRICT ||
              hierarchyValues[0] === CHAPTER ||
              hierarchyValues[0] === REGION ||
              (hierarchyValues[0] === ZONE && ( */}
            {/* <TableCell
              align="left"
              colSpan={5}
              style={{
                ...style.tableHeadCell,
                ...columnCellStyle,
                paddingLeft: "0px",
                marginRight: "0px",
              }}
            >
              {" "}
              <Typography variant="small" weight={600}>
                <Box
                  sx={{
                    marginLeft: "-11px",
                    borderLeft: "1px solid rgba(94, 94, 94, 1)",
                    // borderRight: "1px solid rgba(94, 94, 94, 1)",
                  }}
                >
                  {" "}
                  ORGANIZATION
                </Box>
              </Typography>
            </TableCell> */}
            {/* ))} */}
            <TableCell
              align="left"
              colSpan={13}
              sx={{
                ...style.tableHeadCell,
                ...columnCellStyle,
                paddingLeft: "0px",
              }}
            >
              <Typography
                variant="small"
                weight={600}
                sx={{ color: "#000000" }}
              >
                <Box
                  sx={{
                    marginLeft: "-11px",
                    borderLeft: "1px solid rgba(94, 94, 94, 1)",
                    // borderRight: "1px solid rgba(94, 94, 94, 1)",
                  }}
                >
                  {" "}
                  FRIENDS
                </Box>
              </Typography>
            </TableCell>
            <TableCell
              align="left"
              colSpan={35}
              style={{
                ...style.tableHeadCell,
                ...columnCellStyle,
                paddingLeft: "0px",
                marginRight: "0px",
              }}
            >
              {" "}
              <Typography
                variant="small"
                weight={600}
                sx={{ color: "#000000" }}
              >
                <Box
                  sx={{
                    marginLeft: "-11px",
                    borderLeft: "1px solid rgba(94, 94, 94, 1)",
                    // borderRight: "1px solid rgba(94, 94, 94, 1)",
                  }}
                >
                  {" "}
                  {isBlock
                    ? "APPOINTED LEADERS"
                    : "ORGANIZATION AND APPOINTED LEADERS"}
                </Box>
              </Typography>
            </TableCell>
          </TableRow>
          <TableRow sx={{ padding: "1rem" }}>
            {columns?.map((col, index) => {
              const Component = col.key === "checkBox" ? col.displayName : null;
              return (
                <TableCell
                  key={col.displayName}
                  align="left"
                  rowSpan={col.rowspan ? col.rowSpan : 1}
                  colSpan={col.colSpan ? col.colSpan : 1}
                  style={{ ...style.tableHeadCell, ...columnCellStyle }}
                >
                  <Box
                    sx={{
                      borderRight:
                        index !== columns.length - 1
                          ? "1px solid rgba(94, 94, 94, 1)"
                          : "",
                      paddingRight: "0.6rem",
                    }}
                  >
                    <Typography
                      variant="small"
                      weight={600}
                      style={headCellStyle}
                      sx={{ color: "#000000" }}
                    >
                      {Component ? (
                        <Component
                          sx={{ padding: "3px 14.8px" }}
                          onChange={(e) => checkAllToggle(e.target.checked)}
                        />
                      ) : (
                        col.displayName
                      )}
                    </Typography>
                  </Box>
                </TableCell>
              );
            })}
            {hasAction ? <TableCell sx={style.tableHeadCell} /> : null}
          </TableRow>
        </TableHead>
        <TableBody
          sx={{
            ...style.tableBody,
            "& .MuiTypography-root": {
              fontSize: "14px",
              color: "#000000",
            },
            "tr:nth-child(even)": {
              backgroundColor: "#E8EDF4",
            },
          }}
        >
          {rows}
        </TableBody>
      </MuiTable>
    </TableContainer>
  );
}

const propTypes = {
  checkAllToggle: PropTypes.fun,
  columns: PropTypes.arrayOf(PropTypes.objectOf()).isRequired,
  rows: PropTypes.arrayOf(PropTypes.element).isRequired,
  hasAction: PropTypes.bool,
  columnCellStyle: PropTypes.arrayOf(PropTypes.objectOf()),
  scrollable: PropTypes.bool,
  headCellStyle: PropTypes.objectOf(),
  searchData: PropTypes.arrayOf(PropTypes.objectOf()).isRequired,
};

const defaultProps = {
  hasAction: false,
  scrollable: false,
  columnCellStyle: {},
  headCellStyle: {},
  checkAllToggle: () => {},
};

Table.propTypes = propTypes;
Table.defaultProps = defaultProps;

export default Table;
